import { api } from './apiClient';

// ---------------------------------------------------------------------------
// Price / Rate master service (migration 069). The apiClient auto-unwraps the
// { status, data } envelope, so these resolve to the inner payloads. Inputs
// are camelCase (the ERP validator convention); rows come back snake_case.
// ---------------------------------------------------------------------------

export interface PriceList {
  id: number;
  list_name: string | null;
  price_type: 'CUSTOMER' | 'GENERAL';
  product_id: number;
  product_name?: string | null;
  product_code?: string | null;
  customer_id: number | null;
  customer_name?: string | null;
  effective_from: string;
  effective_to: string | null;
  min_qty: number;
  uom: string | null;
  special_price: number;
  priority: number;
  currency_code: string | null;
  is_active: number | boolean;
}

export interface PriceListInput {
  listName?: string;
  priceType: 'CUSTOMER' | 'GENERAL';
  productId: number;
  customerId?: number | null;
  effectiveFrom: string;
  effectiveTo?: string | null;
  minQty?: number;
  uom?: string;
  specialPrice: number;
  priority?: number;
  currencyCode?: string;
  isActive?: boolean;
}

export interface ResolvedRate {
  rate: number;
  source: 'CUSTOMER_LIST' | 'GENERAL_LIST' | 'BASE_PRICE';
  priceListId: number | null;
}

export const priceListService = {
  list: (filters?: Record<string, any>): Promise<{ priceLists: PriceList[]; count: number }> =>
    api.get('/price-lists', { params: filters }),
  get: (id: number | string): Promise<{ priceList: PriceList }> => api.get(`/price-lists/${id}`),
  create: (payload: PriceListInput): Promise<{ priceList: PriceList }> => api.post('/price-lists', payload),
  update: (id: number | string, payload: Partial<PriceListInput>): Promise<{ priceList: PriceList }> =>
    api.put(`/price-lists/${id}`, payload),
  remove: (id: number | string): Promise<{ success: boolean }> => api.delete(`/price-lists/${id}`),
  resolve: (params: { customerId?: number; productId: number; date?: string; qty?: number }): Promise<ResolvedRate> =>
    api.get('/price-lists/resolve', { params }),
};

export default priceListService;
